<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <!-- <b-link class="brand-logo">
        <img src="@/assets/images/logo/derkoportallogo.png"/>
       
      </b-link> -->
      <!-- /Brand logo-->

      <!-- Left Brand Panel-->
      <b-col
        lg="7"
        class="d-none d-lg-flex align-items-center p-5 derko-brand-panel"
      >
        <div class="derko-brand-inner">
          <div class="derko-logo-pill">
            <b-img
              fluid
              :src="imgUrl"
              alt="Derko Portal"
            />
          </div>
          <div class="derko-brand-copy">
            <h1>Tahsilat ve müşteri yönetimi, tek portalda.</h1>
            <p>Tahsilatlarınızı, müşteri hesaplarınızı ve raporlarınızı hızlı ve güvenle yönetin.</p>
          </div>
          <div class="derko-brand-feats">
            <div class="f"><span class="dot"><feather-icon icon="ZapIcon" size="16" /></span> Hızlı tahsilat akışı</div>
            <div class="f"><span class="dot"><feather-icon icon="LockIcon" size="16" /></span> Güvenli giriş (Parola / OTP)</div>
            <div class="f"><span class="dot"><feather-icon icon="BarChart2Icon" size="16" /></span> Anlık raporlar ve özetler</div>
          </div>
        </div>
      </b-col>
      <!-- /Left Brand Panel-->

      <!-- Login-->
      <b-col
        lg="5"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <!-- Mobil marka başlığı (yalnızca < lg; gradient zemin üstünde, kartın üstünde) -->
        <div class="derko-mobile-header d-lg-none">
          <div class="derko-mobile-logo">
            <b-img
              fluid
              :src="imgUrl"
              alt="Derko Portal"
            />
          </div>
          <p class="derko-mobile-tagline">Tahsilat ve müşteri yönetimi, tek portalda</p>
        </div>

        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto derko-auth-form-col"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            DERKO PORTAL'a hoş geldiniz! 👋
          </b-card-title>
          <b-card-text class="mb-2">
            Sistemi kullanabilmek için lütfen giriş yapınız.
          </b-card-text>

          <!-- Custom Tab Navigation -->
          <div class="custom-tabs-container mb-4">
            <div class="custom-tabs-wrapper">
              <button
                type="button"
                class="custom-tab-btn"
                :class="{ active: activeTab === 'user' }"
                @click="activeTab = 'user'"
              >
                <feather-icon icon="UserIcon" size="18" class="mr-50" />
                Kullanıcı Girişi
              </button>
              <button
                type="button"
                class="custom-tab-btn"
                :class="{ active: activeTab === 'company' }"
                @click="activeTab = 'company'"
              >
                <feather-icon icon="BuildingIcon" size="18" class="mr-50" />
                Müşteri Girişi
              </button>
            </div>
          </div>

          <!-- User Login form -->
          <validation-observer ref="loginValidation" v-show="activeTab === 'user'">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- email -->
              <b-form-group
                label="E-Posta"
                label-for="login-email"
              >
                
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    name="login-email"
                    placeholder="john@example.com"
                  />

              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Parola</label>
                  <!-- <b-link :to="{name:'auth-forgot-password-v2'}">
                    <small>Şifrenizi mi unuttunuz?</small>
                  </b-link> -->
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <!-- <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group> -->

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary" 
                class="d-flex align-items-center justify-content-center"
                block
                :disabled="loading"
                @click="validationForm"
              >
                <b-spinner small class="mr-50" v-if="loading"></b-spinner>
                Giriş Yap
              </b-button>
            </b-form>
          </validation-observer>

          <!-- Company Login form -->
          <validation-observer ref="companyLoginValidation" v-show="activeTab === 'company'">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- Login Method Selection -->
              <b-form-group class="mb-3">
                <label class="form-label">Giriş Yöntemi</label>
                <div class="login-method-tabs">
                  <button
                    type="button"
                    class="method-tab"
                    :class="{ active: companyLoginMethod === 'password' }"
                    @click="selectLoginMethod('password')"
                  >
                    <feather-icon icon="LockIcon" size="16" class="mr-25" />
                    Parola ile Giriş
                  </button>
                  <button
                    type="button"
                    class="method-tab"
                    :class="{ active: companyLoginMethod === 'otp' }"
                    @click="selectLoginMethod('otp')"
                  >
                    <feather-icon icon="SmartphoneIcon" size="16" class="mr-25" />
                    OTP ile Giriş
                  </button>
                </div>
              </b-form-group>

              <!-- Password Login -->
              <div v-if="companyLoginMethod === 'password'">
                <!-- Contact input (email or phone) -->
                <b-form-group>
                  <label for="company-contact">E-Mail Adresi veya Telefon Numarası</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Contact"
                    rules="required"
                  >
                    <b-form-input
                      id="company-contact"
                      v-model="companyContact"
                      :state="errors.length > 0 ? false:null"
                      placeholder="ornek@email.com veya 5XX XXX XX XX"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- Password input -->
                <b-form-group>
                  <label for="company-password">Parola</label>
                  <validation-provider
                    #default="{ errors }"
                    name="CompanyPassword"
                    rules="required"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid':null"
                    >
                      <b-form-input
                        id="company-password"
                        v-model="companyPassword"
                        :state="errors.length > 0 ? false:null"
                        class="form-control-merge"
                        :type="companyPasswordFieldType"
                        placeholder="············"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="companyPasswordToggleIcon"
                          @click="toggleCompanyPasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </div>

              <!-- OTP Login -->
              <div v-if="companyLoginMethod === 'otp'">
                <!-- Contact input with OTP button -->
                <b-form-group>
                  <label for="otp-contact">E-Mail Adresi veya Telefon Numarası</label>
                  <validation-provider
                    #default="{ errors }"
                    name="OtpContact"
                    rules="required"
                  >
                    <b-input-group>
                      <b-form-input
                        id="otp-contact"
                        v-model="otpContact"
                        :state="errors.length > 0 ? false:null"
                        placeholder="ornek@email.com veya +90 5XX XXX XX XX"
                        :disabled="otpSent && !otpExpired"
                      />
                      <b-input-group-append>
                        <b-button
                          variant="outline-primary"
                          :disabled="otpLoading || (otpSent && !otpExpired) || !otpContact"
                          @click="sendOtp"
                        >
                          <b-spinner small v-if="otpLoading" class="mr-50"></b-spinner>
                          <span v-if="!otpSent || otpExpired">OTP Gönder</span>
                          <span v-else-if="otpSent && !otpExpired">{{ formatTime(otpCountdown) }}</span>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- OTP Code input -->
                <b-form-group v-if="otpSent">
                  <label for="otp-code">Doğrulama Kodu</label>
                  <validation-provider
                    #default="{ errors }"
                    name="OtpCode"
                    rules="required|min:6"
                  >
                    <b-form-input
                      id="otp-code"
                      v-model="otpCode"
                      :state="errors.length > 0 ? false:null"
                      placeholder="6 haneli kodu giriniz"
                      maxlength="6"
                      @input="handleOtpInput"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                  <small class="text-muted mt-1">
                    {{ otpSentMethod === 'email' ? 'E-mail adresinize' : 'Telefon numaranıza' }} gönderilen 6 haneli kodu giriniz
                  </small>
                </b-form-group>
              </div>

              <!-- Submit button -->
              <b-button
                v-if="companyLoginMethod === 'password' || (companyLoginMethod === 'otp' && otpCode.length === 6)"
                type="submit"
                variant="primary" 
                class="d-flex align-items-center justify-content-center"
                block
                :disabled="companyLoading"
                @click="validationCompanyForm"
              >
                <b-spinner small class="mr-50" v-if="companyLoading"></b-spinner>
                {{ companyLoginMethod === 'password' ? 'Giriş Yap' : 'OTP ile Giriş Yap' }}
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BSpinner, BNav, BNavItem, BFormRadioGroup
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { AuthApi } from '@/api/auth'
import Auth from '@/utilities/auth'
import { updateAuthHeader } from '@/config/axios.config'



export default {
  watch: {
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BSpinner,
    BNav,
    BNavItem,
    BFormRadioGroup,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      activeTab: 'user', // default tab
      status: '',
      password: '',
      userEmail: '',
      // Company login fields
      companyContact: '', // email or phone for company login
      companyPassword: '',
      companyPasswordFieldType: 'password',
      companyLoginMethod: 'password', // 'password' or 'otp'
      // OTP fields
      otpContact: '', // email or phone number for OTP
      otpCode: '',
      otpSent: false,
      otpLoading: false,
      otpCountdown: 300, // 5 minutes in seconds
      otpTimer: null,
      otpExpired: false,
      otpSentMethod: '', // will be determined automatically from contact format
      sideImg: require('@/assets/images/logo/derkoportallogo.png'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
      loading: false,
      companyLoading: false,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    companyPasswordToggleIcon() {
      return this.companyPasswordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/logo/derkoportallogo.png')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    toggleCompanyPasswordVisibility() {
      this.companyPasswordFieldType = this.companyPasswordFieldType === 'password' ? 'text' : 'password'
    },
    selectLoginMethod(method) {
      this.companyLoginMethod = method
      // Reset form when switching methods
      this.resetCompanyForm()
    },
    resetCompanyForm() {
      this.companyContact = ''
      this.companyPassword = ''
      this.otpContact = ''
      this.otpCode = ''
      this.otpSent = false
      this.otpExpired = false
      this.clearOtpTimer()
    },
    isEmail(text) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(text)
    },
    detectContactMethod(contact) {
      return this.isEmail(contact) ? 'email' : 'sms'
    },
    formatTime(seconds) {
      const mins = Math.floor(seconds / 60)
      const secs = seconds % 60
      return `${mins}:${secs.toString().padStart(2, '0')}`
    },
    startOtpTimer() {
      this.otpCountdown = 300 // 5 minutes
      this.otpExpired = false
      this.otpTimer = setInterval(() => {
        this.otpCountdown--
        if (this.otpCountdown <= 0) {
          this.otpExpired = true
          this.clearOtpTimer()
        }
      }, 1000)
    },
    clearOtpTimer() {
      if (this.otpTimer) {
        clearInterval(this.otpTimer)
        this.otpTimer = null
      }
    },
    handleOtpInput() {
      // Auto-submit when 6 digits are entered
      if (this.otpCode.length === 6 && /^\d{6}$/.test(this.otpCode)) {
        this.$nextTick(() => {
          this.validationCompanyForm()
        })
      }
    },
    validationForm() {
      this.$refs.loginValidation.validate().then(success => {
        if (success) {
          this.loading = true
          AuthApi.Login({
            Email: this.userEmail,
            Password: this.password,
          })
          .then((res)=> {
            this.$result(res)
            this.loading = false
            if(res.data.Success){
              Auth.isAuthenticated = true
              Auth.user = res.data.Data
              // this.$signalr.role.Configure()
              // this.$signalr.notify.Configure()
              // this.$signalr.userActive.Configure()
              if(this.$route.query?.redirect){
                this.$router.push(this.$route.query.redirect)
              }else {
                this.$router.push({name:"home"})
              }
            }
          })
          .catch((err)=> {
            this.loading = false
            this.$result(null,err)
          })
        }
      })
    },
    validationCompanyForm() {
      this.$refs.companyLoginValidation.validate().then(success => {
        if (success) {
          this.companyLoading = true;
          
          const handleSuccess = (res) => {
            this.companyLoading = false;
            this.$result(res);

            if (res.data.Success) {
              const responseData = res.data.Data;
              const isCustomerLogin = !!responseData.CustomerCode;

              Auth.setCustomerData(responseData);

              this.handleCustomerRedirect(responseData, isCustomerLogin);
            }
          };

          const handleError = (err) => {
            this.companyLoading = false;
            this.$result(null, err);
          };

          if (this.companyLoginMethod === 'password') {
            AuthApi.CustomerLogin({
              loginIdentifier: this.companyContact,
              password: this.companyPassword,
            }).then(handleSuccess).catch(handleError);
          } else if (this.companyLoginMethod === 'otp') {
            this.clearOtpTimer();
            AuthApi.VerifyCustomerOtp({
              loginIdentifier: this.otpContact,
              otpCode: this.otpCode,
            }).then(handleSuccess).catch(handleError);
          }
        }
      });
    },
    sendOtp() {
      if (!this.otpContact) return
      
      this.otpLoading = true
      this.otpSentMethod = this.detectContactMethod(this.otpContact)
      
      AuthApi.SendCustomerOtp({
        loginIdentifier: this.otpContact
      })
      .then((res)=> {
        this.$result(res)
        this.otpLoading = false
        if(res.data.Success){
          this.otpSent = true
          this.startOtpTimer()
          // this.$toast({
          //   component: 'ToastificationContent',
          //   props: {
          //     title: 'OTP Gönderildi',
          //     text: `Doğrulama kodu ${this.otpSentMethod === 'email' ? 'e-mail adresinize' : 'telefon numaranıza'} gönderildi.`,
          //     variant: 'success',
          //   },
          // })
        }
      })
      .catch((err)=> {
        this.otpLoading = false
        this.$result(null,err)
      })
    },
    redirectToHome() {
      try {
        if(this.$route.query?.redirect) {
          this.$router.push(this.$route.query.redirect).catch(err => {
            console.log('Navigation handled:', err.message)
          })
        } else {
          this.$router.push({name:"home"}).catch(err => {
            console.log('Navigation handled:', err.message)
          })
        }
      } catch (error) {
        console.log('Router push error:', error)
      }
    },
    // redirectToCustomerDashboard(customerCode) {
    //   try {
    //     this.$router.push({
    //       name: "customer-account-detail", 
    //       params: { code: customerCode }
    //     }).catch(err => {
    //       console.log('Navigation handled:', err.message)
    //     })
    //   } catch (error) {
    //     console.log('Router push error:', error)
    //   }
    // },
    handleCustomerRedirect(responseData, isCustomerLogin) {
      if (isCustomerLogin) { 
        
        if (responseData.HasPassword) {
          this.$router.push({ name: 'customer-portal' }).catch(err => {
            console.log('Müşteri portalına yönlendirme yapıldı:', err.message)
          });
        } else {
          if (this.$route.path !== '/Auth/CustomerPasswordSetup') {
            this.$router.push('/Auth/CustomerPasswordSetup').catch(err => {
              console.log('Şifre oluşturma sayfasına yönlendirildi:', err.message)
            });
          }
        }

      } else if (responseData.RedirectTo) {
        if (this.$route.path !== responseData.RedirectTo) {
          this.$router.push(responseData.RedirectTo).catch(err => {
            console.log('Personel yönlendirmesi yapıldı:', err.message)
          });
        }
      } else {
        this.$router.push({ name: 'home' }).catch(err => {
          console.log('Varsayılan ana sayfaya yönlendirildi:', err.message)
        });
      }
    },
  },
  beforeDestroy() {
    this.clearOtpTimer()
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

// ===============================================================================================
//  DERKO LOGIN — Faz 3 (görsel cila)
//  Marka rengi teal #08a1ae üzerine tutarlı bir dil. Mor (Vuexy varsayılanı) artıkları temizlendi.
//  Yalnızca stil — form mantığı/binding'leri değişmedi.
// ===============================================================================================
$brand: #08a1ae;
$brand-2: #0b8a95;
$brand-soft: rgba(8, 161, 174, 0.12);

// --- Sol marka paneli (teal gradient) ---
.derko-brand-panel {
  position: relative;
  overflow: hidden;
  background: radial-gradient(120% 120% at 80% 10%, rgba(255, 255, 255, 0.16), transparent 52%),
    linear-gradient(155deg, $brand 0%, #16c0cf 60%, #f59e0b 160%);
  color: #fff;

  &::after {
    content: '';
    position: absolute;
    width: 460px;
    height: 460px;
    right: -150px;
    bottom: -180px;
    background: rgba(255, 255, 255, 0.10);
    border-radius: 50%;
  }
  &::before {
    content: '';
    position: absolute;
    width: 240px;
    height: 240px;
    left: -90px;
    top: -70px;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 50%;
  }

  .derko-brand-inner {
    position: relative;
    z-index: 2;
    width: 100%;
    max-width: 460px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 2.5rem;
  }

  .derko-logo-pill {
    align-self: flex-start;
    background: #fff;
    border-radius: 16px;
    padding: 14px 22px;
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.18);

    img {
      max-height: 54px;
      width: auto;
    }
  }

  .derko-brand-copy {
    h1 {
      color: #fff;
      font-size: 2rem;
      font-weight: 800;
      line-height: 1.18;
      letter-spacing: -0.02em;
      margin-bottom: 0.85rem;
    }
    p {
      font-size: 1.05rem;
      line-height: 1.6;
      opacity: 0.92;
      margin-bottom: 0;
      max-width: 26rem;
    }
  }

  .derko-brand-feats {
    display: flex;
    flex-direction: column;
    gap: 0.9rem;

    .f {
      display: flex;
      align-items: center;
      gap: 0.7rem;
      font-size: 1rem;
      opacity: 0.96;
    }
    .dot {
      width: 34px;
      height: 34px;
      flex: 0 0 34px;
      border-radius: 10px;
      background: rgba(255, 255, 255, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

// --- Mobil: tam ekran yenilenmiş arka plan + yüzen form kartı (yalnızca < lg) ---
@media (max-width: 991.98px) {
  // Tüm ekranı kaplayan teal gradient zemin
  .auth-wrapper.auth-v2 {
    background: radial-gradient(130% 90% at 85% 0%, rgba(255, 255, 255, 0.16), transparent 55%),
      linear-gradient(160deg, $brand 0%, #16c0cf 58%, #0b8a95 100%);
  }
  .auth-wrapper.auth-v2 .auth-inner {
    min-height: 100vh;
  }
  // Form sütununun beyaz kutusunu kaldır, dikey diz, ortala
  .auth-wrapper.auth-v2 .auth-bg {
    background: transparent !important;
    flex-direction: column;
    justify-content: center;
    padding: 2rem 1.25rem !important;
  }

  // Üstte beyaz logo rozeti + slogan (gradient üstünde)
  .derko-mobile-header {
    text-align: center;
    margin-bottom: 1.6rem;

    .derko-mobile-logo {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      border-radius: 16px;
      padding: 12px 22px;
      box-shadow: 0 10px 26px rgba(0, 0, 0, 0.20);

      img {
        max-height: 40px;
        width: auto;
      }
    }

    .derko-mobile-tagline {
      margin: 0.9rem 0 0;
      color: #fff;
      font-size: 0.92rem;
      font-weight: 500;
      opacity: 0.96;
    }
  }

  // Formun oturduğu yüzen beyaz kart
  .derko-auth-form-col {
    width: 100%;
    max-width: 420px;
    background: #fff;
    border-radius: 1.4rem;
    padding: 1.9rem 1.5rem !important;
    box-shadow: 0 24px 55px rgba(8, 49, 54, 0.30);
  }

  // Dark modda kart koyu yüzey
  .dark-layout .auth-wrapper.auth-v2 .derko-auth-form-col {
    background: #283046;
  }
}

// --- Üst sekmeler (Kullanıcı / Müşteri) ---
.custom-tabs-container {
  .custom-tabs-wrapper {
    display: flex;
    background: #f1f5f9;
    border-radius: 0.85rem;
    padding: 0.375rem;
    gap: 0.25rem;
  }

  .custom-tab-btn {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.75rem 1rem;
    border: none;
    border-radius: 0.6rem;
    background: transparent;
    color: #64748b;
    font-weight: 600;
    font-size: 0.95rem;
    transition: all 0.25s ease;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &:hover {
      color: $brand;
      background: $brand-soft;
    }

    &.active {
      background: #fff;
      color: $brand;
      box-shadow: 0 2px 8px rgba(15, 23, 42, 0.10);
    }

    .feather {
      margin-right: 0.5rem;
    }
  }
}

// --- Giriş yöntemi sekmeleri (Parola / OTP) ---
.login-method-tabs {
  display: flex;
  background: #f1f5f9;
  border-radius: 0.6rem;
  padding: 0.25rem;
  gap: 0.125rem;
  margin-top: 0.5rem;

  .method-tab {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 0.75rem;
    border: none;
    border-radius: 0.45rem;
    background: transparent;
    color: #64748b;
    font-weight: 600;
    font-size: 0.875rem;
    transition: all 0.2s ease;
    cursor: pointer;

    &:hover {
      color: $brand;
      background: $brand-soft;
    }

    &.active {
      background: $brand;
      color: #fff;
      box-shadow: 0 2px 8px rgba(8, 161, 174, 0.35);
    }

    .feather {
      margin-right: 0.25rem;
    }
  }
}

// --- OTP radyo (kullanılıyorsa) ---
.otp-method-selection {
  .custom-radio {
    .custom-control-label {
      font-weight: 500;
      color: #64748b;

      &::before {
        border: 2px solid #cbd5e1;
        transition: all 0.2s ease;
      }
      &::after {
        background-color: $brand;
      }
    }
    .custom-control-input:checked ~ .custom-control-label::before {
      border-color: $brand;
      background-color: $brand;
    }
  }
}

// --- Form giriş animasyonu ---
.auth-login-form {
  animation: fadeInUp 0.4s ease-out;
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// --- Input odak (teal halka) ---
.form-control:focus {
  border-color: $brand;
  box-shadow: 0 0 0 0.2rem $brand-soft;
}

// --- Birincil buton (teal gradient) ---
.btn-primary {
  background: linear-gradient(135deg, $brand 0%, #16c0cf 100%);
  border: none;
  transition: all 0.25s ease;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 10px 26px rgba(8, 161, 174, 0.4);
  }
  &:active:not(:disabled) {
    transform: translateY(0);
  }
}

.btn-outline-primary {
  border-color: $brand;
  color: $brand;
  transition: all 0.25s ease;

  &:hover:not(:disabled) {
    background: $brand;
    border-color: $brand;
    transform: translateY(-1px);
    box-shadow: 0 4px 15px rgba(8, 161, 174, 0.3);
    color: #fff !important;
  }
}

// --- OTP link / sayaç ---
.text-muted a {
  text-decoration: none;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
}

.input-group-append .btn-outline-primary {
  border-left: none;
  border-color: #cbd5e1;

  &:hover:not(:disabled) {
    border-color: $brand;
  }
  &:disabled {
    background-color: #f8fafc;
    border-color: #e2e8f0;
    color: #64748b;
    opacity: 0.8;
  }
}

.input-group-append .btn-outline-primary span {
  font-family: monospace;
  font-weight: 600;
}

// --- Dark mode uyumu (Faz 4) ---
.dark-layout {
  .custom-tabs-container .custom-tabs-wrapper,
  .login-method-tabs {
    background: #161d31;
  }

  .custom-tabs-container .custom-tab-btn {
    color: #b4b7bd;

    &:hover {
      color: #16c0cf;
      background: rgba(8, 161, 174, 0.18);
    }
    &.active {
      background: #283046;
      color: #16c0cf;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
    }
  }

  .login-method-tabs .method-tab {
    color: #b4b7bd;

    &:hover {
      color: #16c0cf;
      background: rgba(8, 161, 174, 0.18);
    }
    &.active {
      color: #fff;
    }
  }

  .input-group-append .btn-outline-primary:disabled {
    background-color: #283046;
    border-color: #3b4253;
    color: #b4b7bd;
  }
}
</style>
